import { useState } from "react";
import { LayoutDashboard, Package, CreditCard, FileText, Route as RouteIcon, Plane } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Overview from "@/pages/admin/Overview";
import OffersAdmin from "@/pages/admin/OffersAdmin";
import BookingsAdmin from "@/pages/admin/BookingsAdmin";
import VisaFilesAdmin from "@/pages/admin/VisaFilesAdmin";
import PathwaysAdmin from "@/pages/admin/PathwaysAdmin";
import FlightQuotesAdmin from "@/pages/admin/FlightQuotesAdmin";

const TABS = [
  { key: "overview", label: "Tableau de bord", icon: LayoutDashboard, Comp: Overview },
  { key: "offers", label: "Offres", icon: Package, Comp: OffersAdmin },
  { key: "bookings", label: "Réservations & paiements", icon: CreditCard, Comp: BookingsAdmin },
  { key: "visa", label: "Dossiers visa", icon: FileText, Comp: VisaFilesAdmin },
  { key: "pathways", label: "Parcours visa", icon: RouteIcon, Comp: PathwaysAdmin },
  { key: "flights", label: "Devis vol", icon: Plane, Comp: FlightQuotesAdmin },
];

export default function AdminDashboard() {
  const { user } = useAuth();
  const [active, setActive] = useState("overview");
  const ActiveComp = TABS.find((t) => t.key === active)?.Comp;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="font-head text-3xl font-extrabold text-primary">Espace administrateur</h1>
        <p className="text-muted-foreground">Connecté en tant que {user?.email}</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        <aside className="lg:w-64 shrink-0">
          <nav className="flex lg:flex-col gap-1 overflow-x-auto bg-white rounded-2xl soft-shadow border border-gray-100 p-2">
            {TABS.map((t) => {
              const Icon = t.icon;
              return (
                <button
                  key={t.key}
                  onClick={() => setActive(t.key)}
                  data-testid={`admin-tab-${t.key}`}
                  className={`flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold whitespace-nowrap transition-colors ${
                    active === t.key ? "bg-primary text-white" : "text-primary/80 hover:bg-secondary"
                  }`}
                >
                  <Icon className="h-4 w-4" /> {t.label}
                </button>
              );
            })}
          </nav>
        </aside>

        <section className="flex-1 min-w-0">
          {ActiveComp && <ActiveComp />}
        </section>
      </div>
    </div>
  );
}
